import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

/**
 * Lightweight hook that exposes deploy-time info (env_name, adapter_mode,
 * version) from the backend `/health` endpoint. Cached for 5 minutes so
 * the call is essentially free across pages.
 *
 * Useful for conditional UI such as hiding simulator buttons in PROD or
 * showing the correct ENV pill in the header.
 */
export function useEnvInfo() {
  const q = useQuery({
    queryKey: ['env-info'],
    queryFn: async () => (await api.get('/health')).data,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const env = (q.data?.env_name || '').toUpperCase();
  const adapter = (q.data?.adapter_mode || '').toLowerCase();
  const isProduction = adapter === 'live' || ['PROD', 'PRODUCTION'].includes(env);
  const isDemo = !isProduction;

  return {
    envName: env || 'DEMO',
    adapterMode: adapter || 'mock',
    isProduction,
    isDemo,
    loading: q.isLoading,
    data: q.data,
  };
}
